import React from "react";
import {Grid, WindowScroller} from "react-virtualized";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import LoadingSpinner from "../../ui/loadingSpinner";
import SelectionGridItem from "./selectionGridItem";
import SelectionMainVirtualizedFiltersGrid from "./selectionMainVirtualizedFiltersGrid";
import {getWithFilters, useGetFiltersRequest} from "./gridFunctions";
import SelectionGridWizardGroupItem from "./selectionGridWizardGroupItem";
import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";
import {displayMaterialsWizardGroupAsFeature} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";

const SelectionMainVirtualizedGrid = (props) => {

  const {currentFeatures, handleFeatureClick, handleUserLoginClick, listItemHeight, currentParent, filterGroups,
    onScroll, selectionWindowView, checkIfFeatureSelected, scrollElement, fabricatorData, isWizard, currentGroups} = props;
  const {withFilters, filtersLoading} = getWithFilters(currentParent, currentFeatures, filterGroups, fabricatorData);

  useGetFiltersRequest(isWizard, filtersLoading, currentParent, filterGroups);

  if (filtersLoading) {
    return <LoadingSpinner/>
  }

  if (withFilters) {
    return <SelectionMainVirtualizedFiltersGrid currentParent={currentParent}
                                                scrollElement={scrollElement}
                                                onScroll={onScroll}
                                                checkIfFeatureSelected={checkIfFeatureSelected}
                                                currentFeatures={currentFeatures}
                                                handleFeatureClick={handleFeatureClick}
                                                handleUserLoginClick={handleUserLoginClick}
                                                listItemHeight={listItemHeight}/>
  }

  const columnCount = selectionWindowView + 2; // for ex. 1,2,3 view -> 3,4,5 columns

  const cellRenderer = ({columnIndex, key, rowIndex, style}) => {
    let index = (columnCount * rowIndex) + columnIndex;
    if (!currentFeatures[index]) {
      return null
    }

    if (isWizard && displayMaterialsWizardGroupAsFeature(currentGroups)) {
      if (!currentFeatures[index].id) {
        return null
      }
      return (
        <div key={key} style={style}>
          <SelectionGridWizardGroupItem styles={{height: listItemHeight}}
                                        handleFeatureClick={handleFeatureClick}
                                        wizardGroup={currentFeatures[index]}  />
        </div>
      )
    }

    return (
      <div key={key} style={style}>
        <SelectionGridItem
          styles={{
            height: listItemHeight
          }}
          currentFeature={currentFeatures[index]}
          checkIfFeatureSelected={checkIfFeatureSelected}
          handleFeatureClick={handleFeatureClick}
          handleUserLoginClick={handleUserLoginClick}
          isWizard={isWizard}
          wizardGroup={currentGroups ? currentGroups[0] : null}
        />
      </div>
    )
  }

  return (
    <WindowScroller scrollElement={scrollElement}>
      {/*{({ height, isScrolling, onChildScroll, scrollTop, width }) => (*/}
      {() => {
        const width = scrollElement.clientWidth || 0;
        const height = scrollElement.clientHeight || 0;
        return (
          <Grid rowCount={Math.ceil(currentFeatures.length / columnCount)}
                columnCount={columnCount}
                width={width}
                height={height}
                onScroll={onScroll}
                columnWidth={(width / columnCount) - 2}
                rowHeight={listItemHeight + 5}
                cellRenderer={cellRenderer}>
          </Grid>
        )
      }}
    </WindowScroller>
  )
}

SelectionMainVirtualizedGrid.propTypes = {
  currentFeatures: PropTypes.array,
  handleFeatureClick: PropTypes.func.isRequired,
  handleUserLoginClick: PropTypes.func.isRequired,
  checkIfFeatureSelected: PropTypes.func.isRequired,
  onScroll: PropTypes.func,
  currentParent: PropTypes.object,
  listItemHeight: PropTypes.number,
  scrollElement: PropTypes.any, // div
  isWizard: PropTypes.bool,
  currentGroups: PropTypes.arrayOf(PropTypes.shape(wizardGroupInterface)),
}

const mapStateToProps = (store) => {
  const {selectionWindowView} = store.selectionState;
  return {
    filterGroups: store.filterState.filterGroups,
    fabricatorData: store.fabricatorState,
    selectionWindowView
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionMainVirtualizedGrid)
